<template>
  <div class="cate">
    <!-- <van-cell is-link @click="show = true">
      <div class="cate-head">
        <div>分类模式选择</div>
        <van-tag type="warning" size="large">{{ modelName }}</van-tag>
      </div>
    </van-cell>
    <van-popup v-model="show" position="top">
      <ul>
        <li v-for="(item, index) of  cateList" :key="index" @click="routerPush(item)">
          <img :src="item.icon" />
          <p>{{ item.name }}</p>
        </li>
      </ul>
    </van-popup> -->
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!this.$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
  import { Popup, cell, tag } from 'vant';

  const cateList = [
    // {
    //   name: '分类模式1',
    //   icon: require('../../assets/icon/cModel1.png'),
    //   url: 'Model1'
    // },
    {
      name: '分类模式2',
      icon: require('../../assets/icon/cModel2.png'),
      url: 'Model2'
    },
    // {
    //   name: '分类模式3',
    //   icon: require('../../assets/icon/cModel3.png'),
    //   url: 'Model3'
    // }
  ]

  export default {
    beforeRouteLeave(to, from, next) {
      this.cateRouterHistory = from.name
      next();
    },
    components: {
      [Popup.name]: Popup,
      [cell.name]: cell,
      [tag.name]: tag
    },
    data() {
      return {
        cateList,
        show: false
      }
    },
    methods: {
      routerPush(info) {
        this.$router.push({
          name: info.url
        })
        this.show = false
      }
    },
    computed: {
      modelName() {
        const name = this.$route.name
        const result = cateList.find(item => item.url == name)
        return result ? result.name : ''
      }
    },
    activated() {
      this.$router.replace({
        name: this.cateRouterHistory
      })
    },
  }
</script>
<style lang="scss" scoped>
.cate {
  font-size: 0.3rem;

  ul {
    background: #fff;
    padding: 0.2rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      width: 1.2rem;
      padding: 0.1rem;
      text-align: center;

      img {
        width: 1rem;
        height: 1rem;
      }
    }
  }
}

.cate-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>